import React from "react";
import styles from "./EventTitleSkeleton.module.css";
import sharedStyles from "../SkeletonStyles.module.css";

const EventTitleSkeleton = () => {
  return (
    <div className={styles.title_wrap}>
      <div className={styles.title_left}>
        <div
          className={`${styles.title_skeleton} ${sharedStyles.skeleton}`}
        ></div>
        <div
          className={`${styles.org_wrap_skeleton} ${sharedStyles.skeleton}`}
        ></div>
      </div>
      <div className={styles.title_right}>
        <div
          className={`${styles.date_skeleton} ${sharedStyles.skeleton}`}
        ></div>
      </div>
    </div>
  );
};

export default EventTitleSkeleton;
